// ============================================
// USER LAYOUT - Mobil Uyumlu
// ============================================

import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import { UserSidebar } from './UserSidebar';
import { UserHeader } from './UserHeader';
import { MobileTabBar } from './MobileTabBar';
import { SupportButton } from '@/components';

export function UserLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar - desktop: sabit, mobil: overlay */}
      <UserSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Ana İçerik */}
      <div className="md:pl-64">
        {/* Header */}
        <UserHeader onMenuClick={() => setSidebarOpen(true)} />

        {/* Sayfa İçeriği - mobilde alt tab bar için padding */}
        <main className="p-4 md:p-6 pb-20 md:pb-6">
          <Outlet />
        </main>
      </div>

      {/* Mobil Alt Tab Bar */}
      <MobileTabBar onMoreClick={() => setSidebarOpen(true)} />

      {/* Destek Butonu */}
      <SupportButton />
    </div>
  );
}
